export const SET_CITY_SELECTION = "SET_CITY_SELECTION";
export const ADD_CITY_SELECTION = "ADD_CITY_SELECTION";
export const REMOVE_CITY_SELECTION = "REMOVE_CITY_SELECTION";
export const SET_DATASET_SELECTION = "SET_DATASET_SELECTION";
